import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["wrapper", "loginForm", "forgotPasswordForm"]

  connect() {
    this.observer = new MutationObserver(this.dropdownMutated.bind(this))
    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  dropdownMutated() {
    window.feather.replace()

    if ($(this.element).find('#team-chooser').length) window.location.reload()
  }

  showLoginForm(event) {
    event.preventDefault()

    this.forgotPasswordFormTarget.classList.add('hidden')
    this.loginFormTarget.classList.remove('hidden')
  }

  showForgotPasswordForm(event) {
    event.preventDefault()

    this.loginFormTarget.classList.add('hidden')
    this.forgotPasswordFormTarget.classList.remove('hidden')
  }
}